
    <div class="modal-column">
      <a (click)="close($event)" class="icon close-popup" data-id="privacy-close-href">
        <i class="fal fa-times"></i>
      </a>
      <app-privacy-policy></app-privacy-policy>
    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/privacypolicy-modal.component.ts.PrivacypolicyModalComponent.html